import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Bridge from "./pages/Bridge";
import Bridge2 from "./pages/Bridge2";
import BokioriBridge from "./pages/BokioriBridge";
import BridgeGoldttak from "./pages/BridgeGoldttak";
import Bokiori from "./pages/Bokiori";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/bridge" element={<Bridge />} />
      <Route path="/bridge2" element={<Bridge2 />} />
      <Route path="/bokioribridge" element={<BokioriBridge />} />
      <Route path="/goldttakbridge" element={<BridgeGoldttak />} />
      <Route path="/bokiori" element={<Bokiori />} />
    </Routes>
  );
}

export default App;
